<div [ngClass]="layout.config.settings.layout_type">
  <div class="page-wrapper" id="canvas-bookmark" [ngClass]="layoutClass">
    <app-header></app-header>

    <div
      class="page-body-wrapper"
      [ngStyle]="{
        'margin-left': !navServices.collapseSidebar ? 'unset' : '80px'
      }"
    >
      <div
        class="sidebar-wrapper"
        [attr.icon]="layout.config.settings.icon"
        [class.close_icon]="navServices.collapseSidebar"
        [class.close_icon_inverse]="!navServices.collapseSidebar"
        [ngClass]="{ 'compact-sidebar': !navServices.collapseSidebar }"
        [ngStyle]="{
          left: !navServices.collapseSidebar ? '0' : '15rem',
          width: navServices.collapseSidebar ? '85px' : '240px'
        }"
      >
        <app-sidebar></app-sidebar>
      </div>
      <div class="page-body">
        <main [@fadeInAnimation]="getRouterOutletState(o)">
          <router-outlet #o="outlet"></router-outlet>
        </main>
      </div>

      <footer class="footer">
        <app-footer></app-footer>
      </footer>
    </div>
  </div>
</div>
<div class="bg-overlay1"></div>
